import {api} from "./api";

export const getContacts = async ({ page = 1, limit = 10, q = "" }) => {
  const res = await api.get(`/contact/admin?page=${page}&limit=${limit}&q=${encodeURIComponent(q)}`);
  return res.data;
};

export const getContact = async (id) => {
  const res = await api.get(`/contact/admin/${id}`);
  return res.data;
};

export const deleteContact = async (id) => {
  const res = await api.delete(`/contact/admin/${id}`);
  return res.data;
};
